import React, { } from "react";
import { Modal } from "react-bootstrap";
import { ReactComponent as NoFaceIcon } from "../../../images/noFaceIcon.svg"
import { useSelector } from "react-redux";

const MultiFaceModal = () => {
   const multiFaceCount = useSelector((state) => state.warning.multiFaceCount);
   const multiFaceLapseTimeInSec = useSelector((state) => state.warning.multiFaceLapseTimeInSec);

  return (
    <>
      <Modal
         show={(multiFaceCount > multiFaceLapseTimeInSec)}
        // show={show}
        // onHide={handleClose}
        animation={true}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Body>
          <div className="d-flex flex-column align-items-center px-5 py-4 text-center">
            <NoFaceIcon className=""/>
            <h3 className="text-danger px-2">multiple Face Detected!</h3>
            <h6 className="text-info px-3">Multiple Faces seen and captured.</h6>
          </div>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button className="mx-auto calculator-btn" onClick={() => {}}>
            Start Exam
          </Button>
        </Modal.Footer> */}
      </Modal>
    </>
  );
};

export default MultiFaceModal;
